import { Controller } from "@hotwired/stimulus"

// This controller is used to trigger a "click" on a element
// You can specify a delay to delay the click (to avoid firing a click on a hidden element)

export default class extends Controller {
  static get values() {
    return { delay: { type: Number, default: 1 }, }
  }

  click() {
    setTimeout(() => {
      this.element.click()
    }, this.delayValue)
  }
}
